import React from 'react';
import { messages } from '../messages';
import { FormattedMessage } from '@kyruus/intl';
import { Link as RouterLink } from 'react-router-dom';
import { Link } from '@biome-design-system/ui/Link';

import {
  getClearFiltersSearch,
  getLogClearSearchFilters
} from '../../utils/search-common';
import { type GetUpdatedSearch, type Log } from 'Src/types';

interface ClearFiltersProps {
  getUpdatedSearch: GetUpdatedSearch;
  log: Log;
}

export const ClearFilters = ({ getUpdatedSearch, log }: ClearFiltersProps) => {
  // search V8 - searchSummary has 'has_filters' (boolean) key to determine whether filters are applied
  // search V9 - searchSummary has 'filter' (array) key to determine whether filters are applied
  const logClearFilters = getLogClearSearchFilters(log);
  const clearFiltersSearch = getClearFiltersSearch(getUpdatedSearch);
  return (
    <FormattedMessage {...messages.clearfilters}>
      {(message) => (
        <Link
          className="clear-filters"
          component={RouterLink}
          id="clear-filters"
          onClick={() => logClearFilters()}
          to={clearFiltersSearch}
          sx={{ whiteSpace: 'nowrap' }}
          variant="body1"
        >
          {message}
        </Link>
      )}
    </FormattedMessage>
  );
};
